import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Search, Store } from 'lucide-react';
import './CSS/ErrorPages.css';

export default function NotFound() {
  const { t } = useTranslation('common');

  return (
    <div className="error-page">
      <div className="error-page-card">
        <p className="error-page-code">404</p>
        <h1 className="error-page-title">{t('errors.notFoundTitle')}</h1>
        <p className="error-page-description">{t('errors.notFoundDescription')}</p>
        <div className="error-page-actions">
          <Link to="/" className="error-page-btn error-page-btn--primary">
            <Home size={18} />
            {t('backToHome')}
          </Link>
          <Link to="/search" className="error-page-btn error-page-btn--secondary">
            <Search size={18} />
            {t('errors.browseProducts')}
          </Link>
          <Link to="/boutiques" className="error-page-btn error-page-btn--secondary">
            <Store size={18} />
            {t('boutiques', { defaultValue: 'Boutiques' })}
          </Link>
        </div>
      </div>
    </div>
  );
}
